// @core/api/endpoints/authz/write_tuples.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TupleChangeEvent,
  WriteTuplesResponse,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * Write authorization tuples (internal API)
 * Creates or updates relationship tuples in the authorization system. This is an internal API primarily for admin or emergency use; services should publish TupleChangeEvent to the authz.tuple.write Kafka topic for asynchronous processing with full audit trail.
 */
export async function WriteTuples(
  data: TupleChangeEvent,
  options?: RequestOptions
): Promise<WriteTuplesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tuples/write`;
  const requestOptions = options;
  return client.post<WriteTuplesResponse>(requestPath, data, requestOptions);
}
